/**
 * Returns a nice object with metrics, including outerwidth which includes marginLeft and -Right
 * Be aware that accessing these props will cause a reflow, so be sure to never call this
 * during animation and always wrap immediate subsequent DOM modifications in RAF
 * @param element {HTMLElement}
 */
export function getElementHorizontalMetrics(element) {
	const { offsetWidth, offsetLeft } = element
	let { marginLeft, marginRight, paddingLeft, paddingRight } = window.getComputedStyle(element)
	let pageOffsetLeft = 0
	marginLeft = parseInt(marginLeft, 10)
	marginRight = parseInt(marginRight, 10)
	paddingLeft = parseInt(paddingLeft, 10)
	paddingRight = parseInt(paddingRight, 10)

	while (element.offsetParent) {
		pageOffsetLeft += element.offsetLeft
		element = element.offsetParent
	}

	return {
		marginLeft,
		marginRight,
		paddingLeft,
		paddingRight,
		pageOffsetLeft,
		offsetLeft,
		offsetWidth,
		outerWidth: offsetWidth + marginLeft + marginRight
	}
}

/**
 * Same as above, but for vertical metrics
 * @param element {HTMLElement}
 */
export function getElementVerticalMetrics(element) {
	const { offsetHeight, offsetTop } = element
	let { marginTop, marginBottom, paddingTop, paddingBottom } = window.getComputedStyle(element)
	let pageOffsetTop = 0
	marginTop = parseInt(marginTop, 10)
	marginBottom = parseInt(marginBottom, 10)
	paddingTop = parseInt(paddingTop, 10)
	paddingBottom = parseInt(paddingBottom, 10)

	while (element.offsetParent) {
		pageOffsetTop += element.offsetTop
		element = element.offsetParent
	}

	return {
		marginTop,
		marginBottom,
		paddingTop,
		paddingBottom,
		pageOffsetTop,
		offsetTop,
		offsetHeight,
		outerHeight: offsetHeight + marginTop + marginBottom
	}
}
